import type { REVIEW_LABELS } from "@/shared/lib/assetBrowseFilters";
import { CheckCircleIcon, CircleHalfIcon, CircleNotchIcon, XCircleIcon } from "./icons";

const statusIcons = {
  needs_review: { Icon: CircleHalfIcon, color: "var(--warning-text)" },
  in_progress: { Icon: CircleNotchIcon, color: "var(--media-text-text)" },
  approved: { Icon: CheckCircleIcon, color: "var(--success-text)" },
  rejected: { Icon: XCircleIcon, color: "var(--danger-text)" },
} satisfies Record<keyof typeof REVIEW_LABELS, unknown>;

/** Paired with a status label; semantic colors stay visible in highlighted controls. */
export function ReviewStatusIcon({ status = "needs_review" }: { status?: keyof typeof REVIEW_LABELS }) {
  const { Icon, color } = statusIcons[status];
  return <Icon style={{ color }} />;
}
